import { ROUTE_UI_SECTION_NAME } from '../constants/route'

import { useInitData } from './useInitData'

export function useIsProviderProfileNGAvailable() {
  const { availableSections } = useInitData()

  return !!availableSections?.[ROUTE_UI_SECTION_NAME.providerProfileDetail]
}
